import {Injectable} from '@angular/core';
import {HttpService} from './http.service';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs/Observable';
import {NotificationTableRowModel} from '../models/NotificationTableRowModel';
import {HttpResponse} from '@angular/common/http';

@Injectable()
export class NotificationsService {

    constructor(private httpService: HttpService) {}

    getAllNotifications(): Observable<HttpResponse<Array<NotificationTableRowModel>>> {
        const url = environment.ENDPOINTS.GET_ALL_NOTIFICATIONS;
        return this.httpService.getJson<Array<NotificationTableRowModel>>(url);
    }
}



// WEBPACK FOOTER //
// C:/Visual Studio Projects/Novicell Performance Platform/PerformancePlatform/Novicell.Performance.Website/ui/src/app/services/notifications.service.ts